module.exports = __webpack_public_path__ + "img/green_dance.79507813.png";